import { __awaiter, __decorate } from "tslib";
import { observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { logger } from '../utils';
import { foundationErrorBannerTemplate as template } from './error-banner.template';
export const foundationErrorBannerShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
/**
 * @tagname %%prefix%%-error-banner
 * @deprecated
 */
export class ErrorBanner extends FoundationElement {
    connectedCallback() {
        super.connectedCallback();
        logger.deprecated('ErrorBanner', 'Use `${prefix}-banner` instead.');
    }
    /**
     * Dismiss the Error Banner from display.
     */
    dismiss() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.banner.dismiss();
                this.remove();
            }
            catch (e) {
                logger.error(e);
            }
        });
    }
}
__decorate([
    observable
], ErrorBanner.prototype, "error", void 0);
__decorate([
    observable
], ErrorBanner.prototype, "notification", void 0);
/**
 * The Foundation Error Banner
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-error-banner\>
 */
export const foundationErrorBanner = ErrorBanner.compose({
    baseName: 'error-banner',
    template,
    shadowOptions: foundationErrorBannerShadowOptions,
});
